import styled from 'styled-components';

export const PageContainer = styled.section<{isMobile: boolean}>`
  height: ${props => (props.isMobile ? 'calc(100vh - 4rem)' : '100vh')};
`;
